import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from '../config/api-client';
import { ApiUser } from '../constants/ApiUser';
import { UserResponse, UserDetailResponse, UserVerificationRequest, UsersBulkVerificationRequest, UserRoleResponse } from '../types/user';
import { UseMutationOptions, UseQueryOptions } from '../types/react-query';

export const useQueryUser = ({
  query,
  options,
}: {
  query: { roleId?: string, search?: string, institution?: string, acad?: string, program?: string, faculty?: string, status?: string, take?: number, page?: number};
  options?: UseQueryOptions<UserResponse>;
}) =>
  useQuery(
    ['user', query.take, query.page],
    () =>
      apiClient
        .get<unknown, { data: UserResponse }>(ApiUser.userList(query.roleId, query.search, query.institution, query.acad, query.program, query.faculty, query.status, query.take, query.page))
        .then((res) => res.data),
    options,
  );

export const useQueryUserDetail = ({
  query,
  options,
}: {
  query: { userId: string };
  options?: UseQueryOptions<UserDetailResponse>;
}) =>
  useQuery(
    ['userDetail', query],
    () =>
      apiClient
        .get<unknown, { data: UserDetailResponse }>(ApiUser.userDetail(query.userId))
        .then((res) => res.data),
    options,
  );

export const useMutationUserVerification = (options?: UseMutationOptions) =>
  useMutation(
    (data: UserVerificationRequest) =>
      apiClient
        .post<unknown, { data: string }>(`${ApiUser.verifyUser}`, data)
        .then((res) => res.data),
    options,
  );

export const useMutationUsersBulkVerification = (options?: UseMutationOptions) =>
  useMutation(
    (data: UsersBulkVerificationRequest) =>
      apiClient
        .post<unknown, { data: string }>(`${ApiUser.verifyBulkUsers}`, data)
        .then((res) => res.data),
    options,
  );

export const useQueryUserRoleList = ({
    options,
  }: {
    options?: UseQueryOptions<UserRoleResponse>;
  }) =>
    useQuery(
      ['userRoleList'],
      () =>
        apiClient
          .get<unknown, { data: UserRoleResponse }>(ApiUser.userRoleList)
          .then((res) => res.data),
      options,
    );